import { message } from "antd";
import { onCreateGroup, onCreateManyStudent, onCreateStudent, onGetAlLGroupsByProjectId, onGetAllProyectsByEnterpiseID, onGetAllProyectsByenterpiseIdToken, onGetAllResponsesByProjectId, } from "../../api";
import { addOneGrup, addPryects, addResponses, setGroups, setProyectSelected, setStorearrayDataCombined } from "./vrlSlice";
import { onSetArrayData } from "../tableSlice/tableSlice";
import { formatingHeaders } from "../helpers";

export const getAllProjectsByEnterprise = () => {
    return async (dispatch, getState) => {
        const response = await onGetAllProyectsByenterpiseIdToken();
        // console.log("projectos por empresa:", response);
        if (response.status === 0) {
            dispatch(addPryects(response.payload.proyects));
            dispatch(setProyectSelected(response.payload.proyects[0]));
            return response.payload.proyects;
        } else {
            return false;
        }
    };
};

export const setarrayDataCombinedToStore = (payload) => {
    return async (dispatch, getState) => {
        dispatch(setStorearrayDataCombined(payload))
    }
}
export const getAllProjectsByEnterpriseId = (enterpiseId) => {
    return async (dispatch, getState) => {
        const response = await onGetAllProyectsByEnterpiseID(enterpiseId);
        console.log("projectos por empresa:", response);
        if (response.status === 0) {
            dispatch(addPryects(response.payload.proyects));
            dispatch(setProyectSelected(response.payload.proyects[0]));
            return response.payload.proyects;
        } else {
            return false;
        }
    };
};

// move to other slice?
export const createStuden = (payload) => {
    return async (dispatch, getState) => {
        const response = await onCreateStudent(payload.name, payload.userId, payload.groupId);
        console.log("usuario-studiante creado:", response);
        return response;
    };
};

export const createManyStudens = (payload) => {
    return async (dispatch, getState) => {
        const response = await onCreateManyStudent(payload.students, payload.learningGroupId);
        console.log("usuarios creados:", response);
        return response;
    };
};

export const getAllResponsesFormProject = (payload) => {
    return async (dispatch, getState) => {
        const response = await onGetAllResponsesByProjectId(payload);
        console.log("descometar para respuestas crudas de proyecto Learning:");
        console.log("respuestas de proyecto Learning:", response);
        if (response.status === 0) {
            dispatch(addResponses(response.payload.responses));
            const headers = formatingHeaders(response.payload.responses);
            // if (payload === "66155e601e91fe7bde671941") {
            //     console.clear();
            //     console.log("SimiAR---------------------");
            //     console.log(response.payload.responses);
            //     const idsUnicos = new Set();
            //     response.payload.responses.forEach((objeto) => {
            //         idsUnicos.add(objeto.student.userId);
            //     });
            //     const matriculasnotRepeat = Array.from(idsUnicos);
            //     console.log(matriculasnotRepeat);
            //     const arrayUserIntents = [];
            //     let innfoResumeUser = {};
            //     matriculasnotRepeat.forEach((id) => {
            //         const resumeRow = {};
            //         let inicioCorrect = 0;
            //         let finCorrect = 0;
            //         let timeTotal = 0;
            //         console.log("id:------- " + id);
            //         response.payload.responses.forEach((objeto) => {
            //             if (objeto.student.userId === id) {
            //                 innfoResumeUser = { ...objeto, createdAt: new Date().toISOString() };
            //                 Object.keys(objeto.responses).forEach((key, i) => {
            //                     if (resumeRow[key]) {
            //                         resumeRow[key].intents = resumeRow[key].intents + 1;
            //                         if (objeto.responses[key].time && objeto.responses[key].time <= resumeRow[key]) {
            //                             timeTotal += parseInt(objeto.responses[key].time);
            //                             resumeRow[key].time = objeto.responses[key].time;
            //                             resumeRow[key].answer = `T:${resumeRow[key].time} - V:${resumeRow[key].intents}`;
            //                         }
            //                     } else {
            //                         resumeRow[key] = { ...objeto.responses[key] };
            //                         resumeRow[key].intents = 1;
            //                         if (objeto.responses[key].time) {
            //                             timeTotal += parseInt(objeto.responses[key].time);
            //                             resumeRow[key].answer = `T:${resumeRow[key].time} - V:${resumeRow[key].intents}`;
            //                         }
            //                     }
            //                     // conteo de cuestionario iniicio y final
            //                     if (key.includes("Final") || key.includes("Inicio")) {
            //                         if (key.includes("Final") && objeto.responses[key].answer === objeto.responses[key].correctAnswer) {
            //                             finCorrect++;
            //                         }
            //                         if (key.includes("Inicio") && objeto.responses[key].answer === objeto.responses[key].correctAnswer) {
            //                             inicioCorrect++;
            //                         }
            //                     }
            //                 });
            //             }
            //         });
            //         console.log(resumeRow);
            //         console.log(inicioCorrect);
            //         console.log(finCorrect);
            //         arrayUserIntents.push({
            //             ...innfoResumeUser,
            //             durationInSeconds: timeTotal,
            //             responses: {
            //                 ...resumeRow,
            //                 inicio: {
            //                     answer: inicioCorrect,
            //                     correctAnswer: inicioCorrect,
            //                     question: "inicio",
            //                 },
            //                 fin: {
            //                     answer: finCorrect,
            //                     correctAnswer: finCorrect,
            //                     question: "fin",
            //                 },
            //             },
            //         });
            //     });
            //     console.log(arrayUserIntents);
            //     dispatch(onSetArrayData(formatinData([...arrayUserIntents, ...response.payload.responses], headers, "66155e601e91fe7bde671941")));
            // } else {
            // dispatch(onSetArrayHeaders(headers));
            // console.log(response.payload.responses.filter(r => r.student && r.student.userId === "513058"))
            dispatch(onSetArrayData(formatinData(response.payload.responses, headers)));
            // }

            return true;
        } else {
            message.error("No se consiguieron datos, recarga la pagina");
            return false;
        }
    };
};

export const getAllGroups = (payload) => {
    return async (dispatch, getState) => {
        const response = await onGetAlLGroupsByProjectId(payload);
        console.log(response);
        if (response.status === 0) {
            dispatch(setGroups(response.payload));
            return true;
        } else {
            message.error("error al crear grupo");
            return false;
        }
    };
};

export const createGroup = (payload) => {
    return async (dispatch, getState) => {
        const response = await onCreateGroup(payload.name, payload.projectId);
        dispatch(addOneGrup({ grup: [response.payload.group] }));
        if (response.status === 0) {
            return response.payload.group;
        } else {
            message.error("error al crear grupo");
            return false;
        }
    };
};

// const formatingForTable = (responses) => {
// 	const correctAnswers = ["Respuestas", "00"];
// 	responses.forEach((response) => {});
// };

const formatinData = (responses, headersFormated, idProyect) => {
    const data = [];
    let idProyectbase = ""
    // const opciones = {
    // 	year: "numeric", // año con cuatro dígitos (ejemplo: "2023")
    // 	month: "long", // nombre completo del mes (ejemplo: "abril")
    // 	day: "numeric", // día del mes con uno o dos dígitos (ejemplo: "11")
    // 	hour: "numeric", // hora en formato de 12 horas (ejemplo: "12")
    // 	minute: "numeric", // minutos con uno o dos dígitos (ejemplo: "34")
    // };

    responses.forEach((response, i) => {
        const res = {};
        res.Nombre = response.student.name;
        // res.tiempo_total = response
        //res.Fecha_y_hora = new Date(response.createdAt).toLocaleString("es-ES", opciones);
        res.Fecha_y_hora = response.createdAt;
        res.matricula = response.student.userId;
        res._idUser = response.student._id
        res.grupo = response.group.name;
        const questions = response.responses;
        // res[`${Object.keys(question)[0].trim().split(" ").join("_")}`] = question[Object.keys(question)[0]].respuesta;
        res.key = `${i}`;
        let correctAnswers = 0;
        let incorrectAnswers = 0;


        if (response.group.projectId === "672e4328031ac03e79f58508") {
            if (Object.keys(responses).some(key => key.includes("M1"))) {
                if (response.durationInSeconds > 10) {
                    res.tiempo_total = 0.16 + " min";
                }
                else {
                    res.tiempo_total = (parseFloat(response.durationInSeconds) / 60) + " min";
                }
            }
            else {
                if (response.durationInSeconds > 60) {
                    res.tiempo_total = 1 + " min";
                }
                else {
                    res.tiempo_total = (parseFloat(response.durationInSeconds) / 60) + " min";
                }
            }
        }
        else {
            if (response.durationInSeconds < 60) {
                res.tiempo_total = 1 + " min";
                res.tiempo_intento = 1
            }
            else {
                res.tiempo_total = Math.round(parseInt(response.durationInSeconds) / 60) + " min";
                res.tiempo_intento = Math.round(parseInt(response.durationInSeconds) / 60)
            }
        }

        if (response.group.projectId === "679965563ed6fed031d3b488") {
            res.responsesOriginal = response.responses
            const findedusers = responses.filter(resp => resp.student.userId === response.student.userId)
            console.log(findedusers)
            let completedDesafies = 0
            const defaultV = [
                "LP01_EPP_EquipodeProteccionPersonal",
                "LP01_LOTO_Despaletizadora",
                "LP01_LOTO_Paletizadora",
                "LP01_SAM_PaletizadorayDespaletizadora",
                "LP03_EPP_EquipodeProteccionPersonal",
                "LP03_LOTO_RinserLlenadorayCapsulador",
                "LP03_SAM_RinserLlenadorayCapsulador",
                "LP03_02_EPP_EquipodeProteccionPersonal",
                "LP03_02_SAM_Paletizadora",
                "LP03_02_LOTO_Paletizadora",
                "LP03_02_SAM_Envolvedora",
                "LP03_02_LOTO_Envolvedora",
                "LP06_02_EPP_EquipodeProteccionPersonal",
                "LP06_02_LOTO_Envolvedor",
                "LP06_02_LOTO_PaletizadoraMagazindePallets",
                "LP06_02_SAM_Envolvedor",
                "LP06_02_SAM_PaletizadoraMagazindePallets",
                "LP06_EPP_EquipodeProteccionPersonal",
                "LP06_LOTO_MixerRinserLlenadorayCapsulador",
                "LP06_SAM_MixerRinserLlenadorayCapsulador",
                "LP07_EPP_EquipodeProteccionPersonal",
                "LP07_LOTO_LlenadoraySopladora",
                "LP07_SAM_LlenadoraySopladora",
                "LP07_02_EPP_EquipodeProteccionPersonal",
                "LP07_02_SAM_Paletizadora",
                "LP07_02_LOTO_Paletizadora",
                "LP07_02_SAM_Envolvedora",
                "LP07_02_LOTO_Envolvedora",
            ]
            defaultV.forEach(key => {
                // findedusers.forEach(resp => {
                if (findedusers[findedusers.length - 1].responses[key] && findedusers[findedusers.length - 1].responses[key].isCompleted) {
                    completedDesafies++
                }
                // })
            })
            console.log(completedDesafies)
            res.completedDesafies = completedDesafies
        }

        // if (res.matricula === "513058") {
        //     console.log(res.tiempo_total)
        // }
        if (questions) {
            Object.keys(questions).forEach((key) => {
                res[`${key.trim().split(" ").join("_")}`] = questions[key].answer;
                if (questions[key].answer === questions[key].correctAnswer) {
                    correctAnswers++;
                } else {
                    incorrectAnswers++;
                }
            });
        }
        if (response.group.projectId === "672e4328031ac03e79f58508") {
            idProyectbase = "672e4328031ac03e79f58508"
            const percentage = Math.round((correctAnswers / (20)) * 100);
            res.Porcentaje_total = `${percentage}%`;
            res.puntaje = `${percentage}/100`;
        }
        else {
            const percentage = Math.round((correctAnswers / (correctAnswers + incorrectAnswers)) * 100);
            res.Porcentaje_total = `${percentage}%`;
            res.puntaje = `${percentage}/100`;
        }
        // if (res.matricula === "0100" && res.Fecha_y_hora.includes("2024-11-11")) {
        //     console.log(response)
        //     console.log(correctAnswers, incorrectAnswers)
        //     console.log(res)
        // }
        if (idProyect === "66155e601e91fe7bde671941") {
            if (questions.inicio || questions.fin) {
                let numberOfResponses = 0;
                if (questions.inicio) {
                    numberOfResponses -= 1;
                }
                if (questions.fin) {
                    numberOfResponses -= 1;
                }
                numberOfResponses += Object.keys(questions).length;
                res.Porcentaje_total = `${Math.round((numberOfResponses / 32) * 100)}%`;
            } else {
                res.Porcentaje_total = `${Math.round((Object.keys(questions).length / 32) * 100)}%`;
            }
        }

        // average += percentage;
        data.push(JSON.parse(JSON.stringify(res)));
    });
    // para la crad de % completado pro persona
    // dispatch(setAverageResponses(average / responses.length));
    if (idProyectbase === "672e4328031ac03e79f58508") {

        data.forEach(element => {
            // if (element.matricula === "158662") {
            //     console.log(element)
            // }
            let date = ""
            if (element.M4_L5) {
                date = element.Fecha_y_hora.substring(0, 10)
                data.forEach((res) => {
                    if (res.matricula === element.matricula && res.Fecha_y_hora.substring(0, 10) === date) {
                        res.Porcentaje_total = "Completado"
                        res.puntaje = "100/100"
                    }
                })
            } else if (element.Porcentaje_total !== "Completado") {
                element.Porcentaje_total = "En progreso"
                element.puntaje = "En progreso"
            }
        })
    }

    const resultado = {};

    data.forEach(item => {
        const matricula = item.matricula;
        const tiempoEnMinutos = parseFloat(item.tiempo_total.split(' ')[0]);

        if (!resultado[matricula]) {
            resultado[matricula] = { ...item, tiempo_total: tiempoEnMinutos };
        } else {
            resultado[matricula].tiempo_total += tiempoEnMinutos
        }
    });
    // console.log(resultado);
    // data.forEach(element => {
    //     if (element.matricula === "140641") {
    //         console.log(element)
    //     }
    // })

    data.forEach(element => {
        element.tiempo_total = resultado[element.matricula].tiempo_total + " min"
    });
    console.log(data)
    return data;
};


